import React, { useState } from "react"
import { Text, Button, Overlay, WarningIcon, Link } from '@pancakeswap/uikit'
import styled from "styled-components"
import { MEDIUM_DISCLAIMER_URL } from '../../../config'




const DisclaimerModal = styled.div<{ pageHeight: number }>`
    position: fixed; 
    z-index: 1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #0A0B44;
    box-shadow: 0px 20px 36px -8px rgba(14, 14, 44, 0.1), 0px 1px 1px rgba(0, 0, 0, 0.05);
    border-radius: 12px;
    text-align: center;
    align-items:center;
    padding: 24px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width:350px;
    max-height: ${({ pageHeight }) => (pageHeight)}px;
    ${({ theme }) => theme.mediaQueries.sm} {
      width:650px;
     
    } 
  
    ${({ theme }) => theme.mediaQueries.xxl} {
      width:550px;
      height: auto;
      margin-top:unset;
     
    } 

   
`
const DisclaimerInnerTextContainer = styled.div<{ maxHeight?: number }>`
  margin-top:12px;
  overflow: auto;
  max-height: ${({ maxHeight }) => (maxHeight)}px;

`

const DisclaimerText = styled(Text)`
  font-weight: 500;
  font-size: 11px;
  line-height: 24px;
`
const DisclaimerHeadline = styled(Text)`
  font-style: normal;
  font-weight: 700;
  font-size: 25px;
  line-height: 24px;
  `
const DisclaimerButton = styled(Button)`
  font-weight: 700;
  font-size: 13px;
  line-height: 24px;
  width: 100%;
  color:#0C0032;
`
const DisclaimerMediumButton = styled(DisclaimerButton)`
  background-color: #80809E;
`
const ButtonLink = styled(Link)`
  &:hover {
    text-decoration: unset;
}

`
const DisclaimerOverlay = styled(Overlay)`
  z-index: 999;

`


const Disclaimer: React.FC = () => {
  const [PageHeight] = useState(window.innerHeight);
  const disclaimerStorageValue: boolean = JSON.parse(localStorage.getItem('AcceptShimmerSeaDisclaimer'))
  const [hideModal, setHideModal] = useState(disclaimerStorageValue)

  const storeDisclaimer = () => {
    localStorage.setItem("AcceptShimmerSeaDisclaimer", "true")
    setHideModal(true)
  };
  if (!hideModal)
    return (
      <DisclaimerOverlay>
        <DisclaimerModal pageHeight={PageHeight - 50}>
          <WarningIcon width={62} color="#00E9F9" />
          <Text fontSize="20px" mt="12px">ShimmerSea Disclaimer</Text>
          <DisclaimerHeadline mt="12px" color="primary">Acknoledgement </DisclaimerHeadline>
          <DisclaimerHeadline color="primary">of Terms of Use</DisclaimerHeadline>
          <DisclaimerInnerTextContainer maxHeight={PageHeight - 460}>
            <DisclaimerText mt="12px">
              Use of the shimmersea.exchange website, services, dapp, or application is subject to the following terms
              of us and I hereby confirm that by proceeding and interacting with the protocol I am aware of these and accept them in full:
            </DisclaimerText>
            <DisclaimerText color="_tangle50ShadesOfGray" mt="12px">
              Shimmersea.exchange is a smart contract protocol on the Shimmer Staging network,
              and even though multiple security audits have been completed on the smart contracts,
              I understand the risks associated with using the ShimmerSea protocol and associated functions.
            </DisclaimerText>
            <DisclaimerText color="_tangle50ShadesOfGray" mt="12px">
              Any interactions that I have with the associated ShimmerSea protocol apps, smart contracts or any related functions MAY place my funds at risk,
              and I hereby release the ShimmerSea protocol and its contributors, team members,
              and service providers from any and all liability associated with my use of the above-mentioned functions.
            </DisclaimerText>
            <DisclaimerText color="_tangle50ShadesOfGray" mt="12px">
              I am lawfully permitted to access this site and use the Shimmersea.exchange application functions,
              and I am not in contravention of any laws governing my jurisdiction of residence or citizenship.
            </DisclaimerText>
          </DisclaimerInnerTextContainer>
          <DisclaimerButton
            mt="48px"
            onClick={storeDisclaimer}>
            I understand the risks involved, proceed to the app
          </DisclaimerButton>
          <ButtonLink href={MEDIUM_DISCLAIMER_URL} target="_blank" style={{ width: '100%' }}>
            <DisclaimerMediumButton
              width="100%"
              mt="12px"
              mb="24px"
            >
              Read more about it on the Medium article
            </DisclaimerMediumButton>
          </ButtonLink>

        </DisclaimerModal>
      </DisclaimerOverlay>
    )

  return <></>
}

export default Disclaimer